require('./bootstrap');
require('./vue');
//require('./paint');